import {
  Component, ElementRef, EventEmitter, Input, Output,
  ViewChild
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MessageService, MessageType} from "@alpha/services";

@Component({
  selector: 'tagger',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tagger.component.html',
  styleUrls: ['./tagger.component.scss']
})
export class TaggerComponent {

  constructor(private ms:MessageService) {
  }

  @ViewChild("input") input: ElementRef = new ElementRef(null);

  @Output() change: EventEmitter<any> = new EventEmitter();

  @Input() values: string[] | any = [];

  remove(item: string) {
    this.values = this.values.filter((v: any) => v != item);
    this.change.emit(this.values)
  }

  add() {
    const input_value = this.input.nativeElement.value;
    if (input_value != "") {
      if (!this.values.find((v: any) => v == input_value)) {
        this.values = [...this.values, input_value];
        this.change.emit(this.values)
      } else {
        this.ms.set({
          type: MessageType.Warning,
          message: `This tag already exists.`,
          delay: 2500,
        });
      }
      this.input.nativeElement.value = "";
    }
  }

  keyup(_event: KeyboardEvent) {
    if (!!this.input.nativeElement.value) {
      this.input.nativeElement.value = this.input.nativeElement.value
        .replace(/ /g, "")
        .replace(/-/g, "");
    }
  }

  keydown(event: KeyboardEvent) {
    if (event.key === "Tab" || event.key === "," || event.key === "Enter") {
      event.preventDefault();
      this.add();
    }
  }

}
